import React from 'react';
import classes from './CategoriesFilter.module.css';
import ContentCategorySelector from 'components/Posts/PostForm/ContentCategorySelector/ContentCategorySelector';
import { categories } from 'shared/utility';

const categoriesFilter = (props) => {
  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);

  const selectAll = () => {
    props.select(categories, 'categories', true);
  };

  const selectCategory = (categoryName) => {
    props.select([categoryName], 'categories');
  };
  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.Categories}>
        <ContentCategorySelector clicked={selectCategory} selectedCategories={props.categories} type="FilterCategorySelector" />
      </div>
      <div className={classes.Controls}>
        <div className={classes.SelectOptions}>
          <p onClick={selectAll}>Select All</p>
          <p onClick={props.clear}>Clear</p>
        </div>
        <p onClick={props.submit}>SAVE</p>
      </div>
    </div>
  );
};

export default categoriesFilter;
